import { PersonSearchOutlined as PersonSearchIcon } from "@mui/icons-material";
import React from "react";
import { useTranslation } from "react-i18next";
import EmptyState from "../../EmptyState";

const FreelancerNotFound: React.FC = () => {
	const { t } = useTranslation();

	return (
		<EmptyState
			icon={
				<PersonSearchIcon
					sx={{
						fontSize: 80,
						color: "white"
					}}
				/>
			}
			title={t("freelancerNotFound.title")}
			message={t("freelancerNotFound.message")}
			iconBackgroundGradient="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
			iconBoxShadow="0 10px 30px rgba(102, 126, 234, 0.3)"
		/>
	);
};

export default FreelancerNotFound;
